var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSushi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 128C0 57.307 57.307 0 128 0C198.693 0 256 57.307 256 128C256 198.693 198.693 256 128 256C57.307 256 0 198.693 0 128ZM172.499 65.4998C215.832 93.8332 239.166 133.833 226.666 153L188.333 209.667C174.999 228.833 129.999 220.5 87.4988 191.333C79.1655 185.5 71.6655 179.666 64.1655 173C64.5982 172.938 65.0402 172.862 65.4906 172.772C37.765 147.181 23.9101 119.51 33.5493 103.149L33.3325 103L71.6658 47.1666C84.9992 27.9999 129.999 35.4998 172.499 65.4998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.341 149.896C209.674 166.563 168.841 158.23 129.674 130.73C89.6743 103.23 66.341 68.2297 78.0076 51.5631C89.6743 34.8964 130.508 43.2297 169.674 70.7297C208.841 98.2297 232.174 133.23 221.341 149.896ZM184.674 124.896C178.841 133.23 158.841 129.063 138.841 115.73C119.674 102.396 108.008 84.8964 113.841 76.5631C119.674 68.2297 139.674 72.3964 159.674 85.7297C178.841 99.0631 190.508 116.563 184.674 124.896Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSushi);
export default __webpack_public_path__ + "static/media/sushi.da714850.svg";
export { ForwardRef as ReactComponent };